import axios from "axios";

const getCensusLocalities = async () => {
    try {
        const {data} = await axios({
            method: "get",
            url: `https://georef.sitenso.link/api/census-localities`,
            responseType: 'json'
        });
        return data

    } catch (error) {
        console.error("getCensusLocalities",error)
    } 
}

export default getCensusLocalities